import { combine } from "effector";
import {$app} from "./app";
import {$modals} from "./modals";

export const $store = combine({
	app: $app,
	modals: $modals,
});
